import { FileCheck } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import heroImage from "@/assets/registered-agent.jpg";

const RegisteredAgent = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Registered Agent Services</h2>
          <p className="text-lg text-muted-foreground">
            Professional registered agent services for Texas businesses. We receive service of process, legal notices, and government correspondence on behalf of your company, ensuring compliance with Texas law.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Registered Agent Services" subtitle="Reliable Legal Representation" icon={<FileCheck className="h-16 w-16 text-accent" />} mainContent={mainContent} heroImage={heroImage} />;
};
export default RegisteredAgent;